import { render, staticRenderFns } from "./BboxClassificationData.vue?vue&type=template&id=25fd2661&"
import script from "./BboxClassificationData.vue?vue&type=script&lang=ts&"
export * from "./BboxClassificationData.vue?vue&type=script&lang=ts&"
import style0 from "./BboxClassificationData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports